export const TOGGLE_LOADER = 'TOGGLE_LOADER';
